/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { BusinessStudentCommentOutput } from './businessStudentCommentOutput';

export interface PltBusinessStudentComment {
  id?: string;
  studentComment: BusinessStudentCommentOutput;
}
